import template from './storyToolbar.template.html'
import Controller from './storyToolbar.controller'

export default {
  restrict: 'E',
  template,
  replace: true,
  controllerAs: 'vm',
  controller: Controller,
  bindings: {
    storyObj: '=',
    companySettings: '=',
  },
}
